import { toRelativeURL } from '@/components/ActivityViewers/utils/toRelativeURL'
import { log } from '../log'

export const makeTargetBlankAllLinks = (element?: HTMLDivElement) => {
  if (element) {
    const links = element.getElementsByTagName('a')

    for (let i = 0, len = links.length; i < len; i++) {
      const extension = links[i].querySelector('.attach__extension')?.textContent

      if (!links[i].href) continue

      try {
        const url = new URL(links[i].href)
        const isInternal = url.origin === window.location.origin

        if (extension) {
          const url = new URL(links[i].href)
          links[i].href = toRelativeURL(url.href)
          links[i].download = ''
        } else if (!isInternal) {
          links[i].target = '_blank'
        }
      } catch {
        log('[EditorJS] broken link', links[i].href)
      }
    }
  }
}
